import BasicBadge from '@rover/icons/svg/basic-badge.svg';
import Check from '@rover/icons/svg/check.svg';
import EnhancedBadge from '@rover/icons/svg/enhanced-badge.svg';
import EuBadge from '@rover/icons/svg/eu-badge.svg';
import Fenced from '@rover/icons/svg/fence.svg';
import House from '@rover/icons/svg/house.svg';
import StarSitterRedesign from '@rover/icons/svg/star-sitter-redesign.svg';
import Trophy from '@rover/icons/svg/trophy.svg';
import { Icon } from '@rover/icons/utils';
import theme from '@rover/kibble/tokens/build/rover/es6/theme';

export const HighlightIconsAdapter: Record<string, Icon> = {
  StarSitter: StarSitterRedesign,
  Trophy,
  Fenced,
  House,
  Check,
  EuBadge,
  BackgroundCheck: EnhancedBadge,
  BasicBackgroundCheck: BasicBadge,
};

export const HiglightColorsAdapter: Record<string, string> = {
  green: theme.colors.green[700],
  white: theme.colors.neutral.white,
};

export const HighlightBackgroundColorsAdapter: Record<string, string> = {
  green: theme.colors.green[200],
  yellow: theme.colors.yellow[400],
};
